<template>
  <div class="DepositInfo">
    <bv-top></bv-top>
    <van-panel :key="index" v-for="(item,index) in houseDepMobiles">
      <div slot="header" :key="payIndex" v-for="(payItem,payIndex) in payChannels">
        <van-row type="flex" justify="center" class="wireBottom" v-if="item.tallyFlag ==='N'">
          <van-col style="color:red">房屋已经完成交存</van-col>
        </van-row>
        <div class="titleContent" >{{item.address}}</div>
<!--        <van-row type="flex" justify="space-between">-->
<!--          <van-col span="10">房屋地址</van-col>-->
<!--          <van-col class="conterColor addresAlign">{{item.address}}</van-col>-->
<!--        </van-row>-->
        <van-row type="flex" justify="space-between">
          <van-col span="7">房屋面积</van-col>
          <van-col class="conterColor">{{item.constructArea}}㎡</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="7">交存模式</van-col>
          <van-col class="conterColor">{{item.depositName}}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="7">业主姓名</van-col>
          <van-col class="conterColor">{{item.ownerName}}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="7">业主身份证</van-col>
          <van-col class="conterColor">{{item.ownerCertNo}}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="7">应交金额</van-col>
          <van-col class="dueAmount">￥{{item.dueAmount}}</van-col>
        </van-row>
        <van-row class="wireTop" type="flex" justify="end" v-if="item.tallyFlag ==='Y'">
          <van-col>
            <van-button round type="primary" @click="payCli(payItem.apiUrl,item.houseNo,item.reqNo)">支付
            </van-button>
          </van-col>
        </van-row>
<!--        <van-row type="flex" justify="center" v-if="item.tallyFlag ==='Y'">-->
<!--          <van-col span="14">-->
<!--            <van-button round type="primary" @click="payCli(payItem.apiUrl,item.houseNo,item.reqNo)">支 付</van-button>-->
<!--          </van-col>-->
<!--        </van-row>-->
      </div>
    </van-panel>
  </div>
</template>

<script>
import Top from '@/views/components/Top'
import {houseDepositPay} from '@/api/maintainFund/maintainFund'

export default {
  name: "depositMessage",
  data() {
    return {
      houseDepMobiles: [],
      payChannels: [],
    }
  },
  components: {
    BvTop: Top
  },
  created() {
    console.log('过来了哦')
    // this.houseDepMobiles = this.$route.query.houseDepMobiles;
    // this.payChannels = this.$route.query.payChannels
    // this.houseDepMobiles = sessionStorage.getItem('houseDepMobiles');
    // this.payChannels = sessionStorage.getItem('payChannels');
    this.houseDepMobiles = JSON.parse(sessionStorage.getItem('houseDepMobiles')).houseDepMobiles;
    this.payChannels = JSON.parse(sessionStorage.getItem('payChannels')).payChannels;
    console.log(JSON.parse(sessionStorage.getItem('payChannels')).payChannels)
  },
  methods: {
    payCli: function (apiUrl, houseNo, reqNo) {
      //添加加载状态
      const toast = this.$toast.loading({
        duration: 0,       // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      });
      let second = 2;
      const timer = setInterval(() => {
        second--;
        if (second) {
          toast.message = `加载中...`;
          let param = {
            'apiUrl': apiUrl, 'houseNo': houseNo, 'reqNo': reqNo
          };
          houseDepositPay(param).then(response => {
            // debugger
            this.$toast.clear();
            if(response.data.resultCode === '0000'){
              if(response.data.majorCode === '01'){
                window.location.href = response.data.respUrl;
              }else if(response.data.majorCode === '02'){
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                      appId: response.data.appId,     //公众号名称，由商户传入
                      timeStamp: response.data.timeStamp,         //时间戳，自1970年以来的秒数
                      nonceStr: response.data.nonceStr, //随机串
                      package: response.data.package,
                      signType: response.data.signType,         //微信签名方式：
                      paySign: response.data.paySign //微信签名
                    },
                    function (res) {
                      if (res.err_msg == "get_brand_wcpay_request:ok") {
                        window.location.href = "https://fgj.chifeng.gov.cn/api/authority/weixin/init/maintainFund?t=1234567n";
                      }     // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回
                      //   ok，但并不保证它绝对可靠。
                      // else {
                      //   if (res.err_msg == "get_brand_wcpay_request:cancel") {
                      //     alert("您取消了支付")
                      //   }
                      //   if (res.err_msg == "get_brand_wcpay_request:fail") {
                      //     alert("支付失败,请重新支付");
                      //   }
                      // }
                    }
                )
              }
            }
          })
        } else {
          clearInterval(timer);
          this.$toast.clear();
        }
      }, 1000);

      // let param = {
      //   'apiUrl': apiUrl, 'houseNo': houseNo, 'reqNo': reqNo
      // };
      // this.$toast.loading({
      //   duration: 0,       // 持续展示 toast
      //   forbidClick: true, // 禁用背景点击
      //   loadingType: 'spinner',
      //   message: '加载中...'
      // });
      // // debugger
      // houseDepositPay(param).then(response => {
      //   // debugger
      //   this.$toast.clear();
      //   if(response.data.resultCode === '0000'){
      //     if(response.data.majorCode === '01'){
      //       window.location.href = response.data.respUrl;
      //     }else if(response.data.majorCode === '02'){
      //       WeixinJSBridge.invoke(
      //           'getBrandWCPayRequest', {
      //             appId: response.data.appId,     //公众号名称，由商户传入
      //             timeStamp: response.data.timeStamp,         //时间戳，自1970年以来的秒数
      //             nonceStr: response.data.nonceStr, //随机串
      //             package: response.data.package,
      //             signType: response.data.signType,         //微信签名方式：
      //             paySign: response.data.paySign //微信签名
      //           },
      //           function (res) {
      //             if (res.err_msg == "get_brand_wcpay_request:ok") {
      //               window.location.href = "http://fgj.chifeng.gov.cn/api/authority/weixin/init/maintainFund?t=1234567n";
      //             }     // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回
      //             //   ok，但并不保证它绝对可靠。
      //             // else {
      //             //   if (res.err_msg == "get_brand_wcpay_request:cancel") {
      //             //     alert("您取消了支付")
      //             //   }
      //             //   if (res.err_msg == "get_brand_wcpay_request:fail") {
      //             //     alert("支付失败,请重新支付");
      //             //   }
      //             // }
      //           }
      //       )
      //     }
      //   }
      // })

    }
  },
}
</script>

<style lang='scss'>
.DepositInfo {
  .van-panel {
    border-bottom: 10px solid #e1e1e1;

    .van-row {
      padding: 5px 10px;
      line-height: 26px;

      .conterColor {
        color: #969799;
      }

      .dueAmount {
        color: red;
      }

      .van-button {
        height: 4vh !important;
        line-height: 0;
      }

      .addresAlign {
        text-align: right;
      }
    }

    .wireBottom {
      border-bottom: 1px solid #f2f2f2;
    }

    .wireTop {
      border-top: 1px solid #f2f2f2;
    }
    .titleContent{
      font-size: 15px;
      border-width: 1px;
      display: inline-block;
      font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
      font-weight: 700;
      font-style: normal;
      text-align: left;
    }
  }
}
</style>

